var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"fade-in"}},[_c('img',{staticClass:"logo",attrs:{"src":require(("@/assets/img/png/logo-" + _vm.game + ".png")),"alt":"Game Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }